import ContentSkeleton from "../shared/ContentSkeleton";
import React, { lazy, Suspense } from "react";
import { Box, Alert } from "@mui/material";

const ItemManagement = lazy(() => import("../ItemManagement/itemManagement"));
const OrderManagement = lazy(() =>
  import("../orderManagement/orderManagement")
);
const Enquiry = lazy(() => import("../../forms/enquiryTable/enquiry"));
const BookTable = lazy(() => import("../tableBook/tableBook"));
const Kitchen = lazy(() => import("../kitchen/kitchenMain"));
const StaffManagement = lazy(() => import("../staff/staffNav"));
const Profile = lazy(() => import("../profileDetails/profileDetails"));
const OrderAssign = lazy(() => import("../orderAssign/orderAssign"));
const BillManagement = lazy(() => import("../billManagement/billMain"));
const Subscription = lazy(() => import("../subscription/index"));
const QrOrder = lazy(() => import("../qrMenu/index"));
const MainCourse = lazy(() => import("../MainCourses/index")); // ✅ already added


const ContentRenderer = ({ selectedItem, role, orderPage, onOrderPageChange, kitchenPage, billingPage }) => {
  const renderContent = () => {
    switch (selectedItem) {

      case "Main Course": // ✅ NEW CASE
        return role === "super_admin" || role === "admin" ? (
          <MainCourse />
        ) : (
          <Alert severity="warning">Your account does not have access to this section.</Alert>
        );

      case "Item Management":
        return role === "super_admin" ||
          role === "admin" ||
          role === "kitchen" ||
          role === "waiter" ||
          role === "rider" ? (
          <ItemManagement />
        ) : (
          <Alert severity="warning">Your account does not have access to this section.</Alert>
        );

      case "Staff Management":
        return role === "super_admin" ? (
          <StaffManagement />
        ) : (
          <Alert severity="warning">Your account does not have access to this section.</Alert>
        );

      case "Order Management":
        return <OrderManagement selectedPage={orderPage} onPageChange={onOrderPageChange} />;

      case "Enquiry Management":
        return <Enquiry />;

      case "Book Table":
        return <BookTable />;

      case "Kitchen":
        return <Kitchen selectedPage={kitchenPage} />;

      case "Profile":
        return <Profile />;

      case "Delivery Management":
        return role === "super_admin" ||
          role === "admin" ||
          role === "cashier" ? (
          <OrderAssign />
        ) : (
          <Alert severity="warning">Your account does not have access to this section.</Alert>
        );

      case "Billing Report":
        return role === "super_admin" || role === "cashier" ? (
          <BillManagement selectedPage={billingPage} />
        ) : (
          <Alert severity="warning">Your account does not have access to this section.</Alert>
        );

      case "Subscription":
        return role === "super_admin" || role === "admin" ? (
          <Subscription />
        ) : (
          <Alert severity="warning">Your account does not have access to this section.</Alert>
        );

      case "Qr Order":
        return role === "super_admin" || role === "admin" ? (
          <QrOrder />
        ) : (
          <Alert severity="warning">Your account does not have access to this section.</Alert>
        );

      default:
        return <Box>Select an option from the menu</Box>;
    }
  };

  return <Suspense fallback={<ContentSkeleton />}>{renderContent()}</Suspense>;
};

export default ContentRenderer;
